import columns from '../../../../../react-table/helpers/columns';
import { longestDuration, sumTotal } from '../../../../../react-table/helpers/rowTotals';
import DespatchMonitoringOverviewReportMode from '../DespatchMonitoringOverviewReportMode';

export default (data, reportMode) => {
  const {
    TextColumn,
    NumberColumn,
    DurationColumn,
  } = columns(data);

  return [
    {
      Header: 'Operator',
      columns: [
        new TextColumn('Origin', 'operatorCodes.origin')
          .withTotalHeader('Total'),
        new TextColumn('Destination', 'operatorCodes.destination'),
      ],
    },
    {
      Header: 'IMPC',
      columns: [
        new TextColumn('Origin', 'impcCodes.origin')
          .withShow(reportMode ===
            DespatchMonitoringOverviewReportMode.impc),
        new TextColumn('Destination', 'impcCodes.destination')
          .withShow(reportMode ===
            DespatchMonitoringOverviewReportMode.impc),
      ],
    },
    {
      Header: 'PREDES',
      columns: [
        new NumberColumn('Despatches', 'data.predesTraffic.despatches')
          .withTotalHeader(sumTotal),
        new NumberColumn('Receptacles', 'data.predesTraffic.receptacles')
          .withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new NumberColumn('Despatches', 'data.resdesTraffic.despatches')
          .withTotalHeader(sumTotal),
        new NumberColumn('Receptacles', 'data.resdesTraffic.receptacles')
          .withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'RESDES vs Planned arrival (hours)',
      columns: [
        new NumberColumn('<Planned', 'data.resdesVsPlanning.withinPlan')
          .withTotalHeader(sumTotal),
        new NumberColumn('<=2', 'data.resdesVsPlanning.missedBy2h')
          .withTotalHeader(sumTotal),
        new NumberColumn('>2 <=6', 'data.resdesVsPlanning.missedBy2to6h')
          .withTotalHeader(sumTotal),
        new NumberColumn('>6 <=24', 'data.resdesVsPlanning.missedBy6To24h')
          .withTotalHeader(sumTotal),
        new NumberColumn('>24 <=48', 'data.resdesVsPlanning.missedBy24to48h')
          .withTotalHeader(sumTotal),
        new NumberColumn('>48 <=72', 'data.resdesVsPlanning.missedBy48To72h')
          .withTotalHeader(sumTotal),
        new NumberColumn('>72', 'data.resdesVsPlanning.missedByMoreThan72h')
          .withTotalHeader(sumTotal),
        new NumberColumn('No arrival date', 'data.resdesVsPlanning.noPlannedArrival')
          .withTotalHeader(sumTotal),
        new NumberColumn('Not scanned', 'data.resdesVsPlanning.notScanned')
          .withTotalHeader(sumTotal),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Pl. arr. < Close date', 'data.closedDatesAfterArrivalDatesCount')
          .withTotalHeader(sumTotal),
        new DurationColumn('Max tail', 'data.maxTail')
          .withTotalHeader(longestDuration),
      ],
    },
  ];
};
